import { useEffect, useState } from "react";
import ApiServices from "../services/apiservices";
import { Link } from "react-router-dom";
import { FiClock } from "react-icons/fi";

const MeterPriceList = () => {
  const [posts, setPosts] = useState([]);

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPosts, setTotalPosts] = useState(0);

  const fetchPosts = async () => {
    try {
      const res = await ApiServices.getRequest(`/meter-prices/fetch.php`);

      setPosts(res.posts || []);
      setTotalPages(res.totalPages || 1);
      setTotalPosts(res.totalPosts || 0);
    } catch (error) {
      console.error("Error fetching posts", error);
    }
  };

  useEffect(() => {
    fetchPosts();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  const formatDate = (date) => {
    return new Date(date).toLocaleString("en-NG", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="w-full min-h-screen bg-white font-sans">
   <div className="relative bg-[#14532d] text-white py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight  uppercase tracking-tight">
              MAP Meter <span className="text-yellow-400">Prices</span>
              </h1>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
            </div>
          
          </div>
        </div>
    </div>
    <div className="max-w-5xl mx-auto px-4 py-8">
        {/* Info */}
        <div className="mb-6 flex items-center gap-3 bg-gray-50 px-4 py-2 rounded-xl border border-gray-100 inline-flex">
          <span className="text-[10px] font-bold uppercase text-gray-400 tracking-wider">Page {page} of {totalPages}</span>
          <div className="w-1 h-1 bg-gray-300 rounded-full"></div>
          <span className="text-[10px] font-bold uppercase text-green-700 tracking-wider">{totalPosts} Posts Found</span>
        </div>

        {posts.length === 0 && (
          <div className="text-center text-gray-400 py-20 bg-gray-50 rounded-2xl border-2 border-dashed border-gray-200">
            <div className="text-4xl mb-4">📂</div>
            <p className="text-base font-bold uppercase tracking-tight">No meter price posts available.</p>
          </div>
        )}

        {/* LIST */}
        <div className="grid grid-cols-1 gap-4">
          {posts.map((post) => (
            <Link
              key={post.id}
              to={`/meter-prices/${post.postLinkTitle}`}
              className="group block bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex flex-col md:flex-row">

                {/* LEFT IMAGE */}
                <div className="md:w-[220px] w-full h-[140px] md:h-auto overflow-hidden relative flex-shrink-0">
                  {post.featuredImage ? (
                    <img
                      src={post.featuredImage}
                      alt={post.title}
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-400 font-bold uppercase text-[10px]">
                      <img
                        src="/images/meterpricethumbnail.png"
                        alt={post.title}
                        className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  )}
                  <div className="absolute top-2.5 left-2.5 bg-yellow-400 text-black px-2.5 py-1 rounded-full text-[9px] font-extrabold uppercase tracking-widest shadow">
                    {post.category || "Documents"}
                  </div>
                </div>

                {/* RIGHT CONTENT */}
                <div className="flex-1 p-4 md:p-5 flex flex-col justify-between">
                  <div>
                    <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2 uppercase tracking-tight group-hover:text-green-700 transition-colors line-clamp-1">
                      {post.title}
                    </h3>

                    <p className="text-gray-600 text-xs md:text-sm leading-relaxed line-clamp-2">
                      {post.description || "Official announcement from Benin Electricity Distribution Company regarding MAP meter prices."}
                    </p>
                  </div>

                  {/* Meta */}
                  <div className="flex items-center mt-4 pt-3 border-t border-gray-100 text-[10px]">
                    <div className="flex items-center gap-2 text-gray-400 font-bold uppercase tracking-wider">
                      <FiClock className="text-green-700 text-sm" />
                      {formatDate(post.createdAt)}
                    </div>

                    <span className="ml-auto text-green-700 font-bold uppercase tracking-wider group-hover:translate-x-1 transition-transform">
                      View Details →
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="mt-10 flex flex-col md:flex-row items-center justify-between gap-4 p-6 bg-gray-50 rounded-2xl border border-gray-100">
            <div className="text-[11px] font-bold uppercase tracking-wider text-gray-400">
              Page <span className="text-black">{page}</span> of <span className="text-black">{totalPages}</span>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => setPage((prev) => prev - 1)}
                disabled={page === 1}
                className="px-6 py-2.5 bg-white border border-gray-200 rounded-xl font-bold uppercase tracking-wider text-[10px] hover:border-green-700 hover:text-green-700 disabled:opacity-30 disabled:hover:border-gray-200 disabled:hover:text-gray-400 transition-all shadow-sm"
              >
                ← Prev
              </button>

              <button
                onClick={() => setPage((prev) => prev + 1)}
                disabled={page === totalPages}
                className="px-6 py-2.5 bg-black text-white rounded-xl font-bold uppercase tracking-wider text-[10px] hover:bg-green-700 disabled:opacity-30 disabled:hover:bg-black transition-all shadow-md"
              >
                Next →
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MeterPriceList;